// FIRST, above every other import. ES module imports execute in order, so an exception
// thrown while a module below initialises is only reported if this ran already.
import './core/sentry.js';
import 'jquery';
import './core/jquery-compat.js'; // restores $.camelCase for owl.carousel under jQuery 4
import './core/csrf.js'; // installs the X-CSRF-TOKEN header on every same-origin AJAX call
import dayjs from 'dayjs';

import 'bootstrap/dist/css/bootstrap.min.css';
// Open Sans and Inter are self-hosted. Their @font-face declarations live in
// scss/modules/_font-faces.scss rather than being imported from @fontsource here - see the
// header of that file for why fontsource's own CSS is not used directly (its per-subset files
// download every subset twice; its per-weight files add 43KB of render-blocking CSS).
import '../scss/styles.scss';

// ESM build does not set global.bootstrap; helpers and browse.js use window.bootstrap.
import * as bootstrap from 'bootstrap';
if (typeof window !== 'undefined') {
    window.bootstrap = bootstrap;
}

// owl.carousel is loaded ON FIRST CALL, from ./core/owl.js, which installs a $.fn.owlCarousel
// stub when it evaluates. It is 44KB of JS and 5KB of CSS, and nothing in app/Views or src/js
// calls .owlCarousel() - but a distributor's per-site custom.js under local_resources/ could,
// and that is not in this repo to grep. So it is kept and made lazy rather than removed.
//
// The import below has to stay STATIC for that: custom.min.js is a classic script at the bottom
// of layout.inc, so its ready handler is registered before this module evaluates and runs first.
// The stub has to be on $.fn by then. See the header of core/owl.js.

import { initDateTimePicker, getDateTimePicker } from './core/date-picker.js';
import {
    initTooltip, initPopover, showPopover,
    showModal, hideModal
} from './core/bootstrap-helpers.js';
import { getUrlVars } from './core/utilities.js';

import { resizeStickyContent, buttonAnimation } from './ui/feedback.js';
import { respondNavbarForms, initNavbarForms } from './ui/navbar.js';
import { initEmailPopup, initOrderMethodPopup, initUserMessagePopup } from './ui/popups.js';
import { initOrderingModeModal } from './ui/ordering-mode.js';
import { initUniversalToggle, initToggleDependentController } from './ui/toggle.js';
import { applyViewAsToLinks, withViewAs } from './ui/view-as-links.js';
import { displayToastrAlert } from './ui/toastr-alert.js';

import { resetApplicationFacets, initYMM } from './ymm/ymm-lookup.js';
import { initFitmentApplication } from './ymm/fitment.js';
import { initEngineLookup } from './ymm/engine-lookup.js';
// Gates itself on a hidden input only layout.inc emits - this bundle also loads on
// layout_c.inc and layout_d.inc, where an idle timer must never run. See the module header.
import { initVehicleIdleTimer } from './ymm/vehicle-idle.js';

import { initAjaxForm } from './forms/ajax-form.js';
import { initDeleteButtons } from './forms/delete-buttons.js';
import { initColorPickers } from './forms/color-pickers.js';
import { initHTMLEditors } from './forms/html-editors.js';
import { initDateRangeFilter } from './forms/date-range-filter.js';
import './forms/serialize-object.js';

import { initOwlCarousel } from './core/owl.js';
import { loadSearchBarWhenIdle } from './search/search-bar-loader.js';
import { initBannerCarousels } from './ui/banner-carousels.js';
import { initClipboard } from './clipboard.js';
import { initDataTables } from './data-tables.js';

import { initOrdering } from './ordering/index.js';
import { initCheckoutWarehouseSplit } from './ordering/checkout-warehouse-split.js';
import { setInventoryConfig } from './ordering/inventory.js';
import { initFavorites } from './favorites/index.js';
import { initAccountSearch } from './search/account-search.js';

import { callAsync, setAsUserId } from './async/call-async.js';
import { asyncPostOnload, kitBuilderTableTotals, displayResponseMessage, getAltKitBuilderItems } from './async/post-onload.js';
import { initAsyncHandlers } from './async/handlers.js';

import { initReturns } from './returns.js';
import { initEliteExtraOrders } from './elite-extra.js';
import { initSamsaraDeliveries } from './samsara.js';

$(document).ready(readyPage);

function readyPage() {
    var $productAvailabilityAvailable = $('#product-availability-available');
    var $productAvailabilityOutOfStock = $('#product-availability-out-of-stock');
    var $productAvailabilityUnavailable = $('#product-availability-unavailable');
    var $productAvailabilityBackorder = $('#product-availability-backorder');
    var $productAvailabilityDropship = $('#product-availability-dropship');
    var $productAvailabilityInStock = $('#product-availability-in-stock');
    var $productAvailabilityDropshipAvailable = $('#product-availability-dropship-available');
    var $pricingFallbackMessage = $('#pricing-fallback-message');
    var $disableOrderingOnFallback = $('#disable-ordering-fallback');
    var $stockDisplayCap = $('#stock-display-cap');

    setInventoryConfig({
        productAvailabilityAvailable: $productAvailabilityAvailable.length
            ? $productAvailabilityAvailable.val() : 'Available',
        productAvailabilityOutOfStock: $productAvailabilityOutOfStock.length
            ? $productAvailabilityOutOfStock.val() : 'Out of Stock',
        productAvailabilityUnavailable: $productAvailabilityUnavailable.length
            ? $productAvailabilityUnavailable.val() : 'Unavailable',
        productAvailabilityBackorder: $productAvailabilityBackorder.length
            ? $productAvailabilityBackorder.val() : 'Place on Backorder',
        productAvailabilityDropship: $productAvailabilityDropship.length
            ? $productAvailabilityDropship.val() : 'Manufacturer Drop-Ship',
        productAvailabilityInStock: $productAvailabilityInStock.length
            ? $productAvailabilityInStock.val() : 'In Stock',
        productAvailabilityDropshipAvailable: $productAvailabilityDropshipAvailable.length
            ? $productAvailabilityDropshipAvailable.val() : 'Dropship Available',
        pricingFallbackMessage: $pricingFallbackMessage.length
            ? $pricingFallbackMessage.val() : 'Pricing Unavailable',
        disableOrderingOnFallback: $disableOrderingOnFallback.length
            && $disableOrderingOnFallback.val() == 'true',
        customOrderText: $('#order-text').val(),
        stockDisplayCap: parseInt($stockDisplayCap.val()),
        showStock: $('#show-stock').length
            ? $('#show-stock').val() == 'true' : true,
    });

    buttonAnimation();
    respondNavbarForms();
    resizeStickyContent();
    initNavbarForms();
    initYMM();
    initEngineLookup();
    initFitmentApplication();
    initVehicleIdleTimer();
    loadSearchBarWhenIdle();
    initAccountSearch();
    initAjaxForm();
    initOrdering();
    initCheckoutWarehouseSplit();
    initFavorites();
    initReturns();
    initDeleteButtons();
    initClipboard();
    initBannerCarousels();
    initOwlCarousel();
    initColorPickers();
    initHTMLEditors();
    initDataTables();
    initEliteExtraOrders();
    initSamsaraDeliveries();
    initUserMessagePopup();
    initEmailPopup();
    initUniversalToggle();
    initToggleDependentController();
    initOrderMethodPopup();
    initOrderingModeModal();
    initAsyncHandlers();

    $('[data-bs-toggle="tooltip"]').each(function () {
        initTooltip($(this));
    });

    $(window).resize(function () {
        respondNavbarForms();
        resizeStickyContent();
    });

    $(document).on('scroll', function () {
        // `#main` only exists in the storefront layout, not the admin shell
        // (layout_c.inc uses #cp-main). Guard so admin pages don't throw a
        // TypeError on every scroll tick from `.position()` being undefined.
        var $main = $('#main');
        if ($main.length) {
            if ($(this).scrollTop() >= $main.position().top) {
                $('.navbar-wrapper').addClass('scrolled');
            } else {
                $('.navbar-wrapper').removeClass('scrolled');
            }
        }
        resizeStickyContent();
    });

    setAsUserId($('#au').val());
    applyViewAsToLinks();
    asyncPostOnload();
}

// Expose functions on window for inline scripts in PHP views that still reference them.
// dayjs, exposed for the inline scripts in PHP views. moment is no longer a
// dependency: it was bundled alongside dayjs and only used for these date formats,
// which dayjs supports with the same tokens.
window.dayjs = dayjs;
window.initDateTimePicker = initDateTimePicker;
window.getDateTimePicker = getDateTimePicker;
window.initTooltip = initTooltip;
window.initPopover = initPopover;
window.showPopover = showPopover;
window.showModal = showModal;
window.hideModal = hideModal;
window.getUrlVars = getUrlVars;
// Exposed for the inline DataTables setup in the history views, which cannot import.
// Prefer it over getUrlVars()['au'] for building an ajax url: getUrlVars() regexes the whole
// href INCLUDING the fragment, so `/history#x?au=OTHER` yields a value the server never saw,
// and the usual `href.indexOf('au=')` guard in front of it is undelimited - `?tableau=`,
// `?bureau=` and `?redirect=...au=...` all match it. withViewAs() reads the server-rendered
// #au element instead, so it agrees with the page by construction.
window.withViewAs = withViewAs;
window.displayToastrAlert = displayToastrAlert;
window.resetApplicationFacets = resetApplicationFacets;
window.callAsync = callAsync;
window.kitBuilderTableTotals = kitBuilderTableTotals;
window.displayResponseMessage = displayResponseMessage;
window.getAltKitBuilderItems = getAltKitBuilderItems;
window.initDateRangeFilter = initDateRangeFilter;

// Dynamic page-module router — replaces per-page <script> tags in layout.inc.
// PHP sets window.__PAGE_CTX__ with { segments, isHome, isCP } before this module loads.
(function loadPageModules() {
    var ctx = window.__PAGE_CTX__;
    if (!ctx) return;

    var segments = ctx.segments;
    var isHome = ctx.isHome;
    var isCP = ctx.isCP;
    var s = function (i) { return segments[i] || ''; };

    if (s(0) === 'catalog') {
        import('./partials/letter-links.js');
    }

    // The Locations page (#886) branches on a DOM MARKER, not on a segment, and it is the only
    // branch here that does. Every other page module keys off a fixed first segment, but the
    // Locations slug is a per-site setting (#891) - /locations, /branches, /store-locator - so
    // there is no segment to match against. PHP renders [data-locations-map] only when a Google
    // Maps browser key is configured and at least one published location has coordinates, which
    // makes the marker double as the degrade switch: no marker, no map chunk fetched at all.
    //
    // #887 adds a second marker on the same page, [data-locations-group-filter], which PHP
    // renders only past the location threshold. The two are INDEPENDENT: a site can have groups
    // and no map key, or a map and no groups. They are loaded together so that when both are
    // present the group filter gets the map controller and can drive the pins through its
    // filterPins() seam - the map has no filter of its own and must not grow one.
    var locationsMapNode = document.querySelector('[data-locations-map]');
    var locationsFilterNode = document.querySelector('[data-locations-group-filter]');

    if (locationsMapNode || locationsFilterNode) {
        Promise.all([
            locationsMapNode
                ? import('./partials/locations.js').then(function (m) {
                      return m.initLocations();
                  })
                : Promise.resolve(null),
            locationsFilterNode ? import('./partials/locations-groups.js') : Promise.resolve(null),
        ]).then(function (loaded) {
            // loaded[0] is null whenever the map degraded - no placeable pin, no browser key,
            // no Maps API. The filter still works; it just has nothing to hide pins on.
            if (loaded[1]) {
                loaded[1].initLocationGroups({ controller: loaded[0] });
            }
        });
    }

    // The specials listing rows navigate from data-specials-url, not from an inline onclick
    // with the slug interpolated into it (#953). Loaded for the whole /specials tree rather
    // than for the index alone: the module only attaches one delegated handler, and the
    // detail page simply has no row for it to match.
    if (s(0) === 'specials') {
        import('./partials/specials.js').then(function (m) {
            m.initSpecialsLinks();
        });
    }

    // 'favorites' is here for the availability pipeline and nothing else: the
    // favorites cards carry [data-availability], and product-browse.js is the only
    // implementation of the batched stock/price render. Its readyProductBrowsePage()
    // early-returns unless one of nine has* flags is true, and on /favorites only
    // hasAvailability is - so no fitment, price-manager, lost-sale, gallery or filter
    // code activates. Issue #568.
    //
    // The inner branches below all test s(1), which on /favorites is '' or 'page', so
    // none of them fire. Note the catalog-index branch is (s(0) === 'catalog' && s(1)
    // === ''), scoped to catalog rather than a bare empty s(1) - keep it that way or
    // /favorites would start pulling in browse.js.
    if (
        s(0) === 'order' ||
        s(0) === 'catalog' ||
        s(0) === 'specials' ||
        s(0) === 'favorites'
    ) {
        import('./partials/product-browse.js');

        if (
            s(1) === 'browse' ||
            s(1) === 'categories' ||
            s(1) === 'brands' ||
            (s(0) === 'catalog' && s(1) === '') ||
            s(0) === 'specials'
        ) {
            import('./partials/browse.js');
        } else if (s(1) === 'item') {
            import('./partials/product.js');
            // The supersession alert's stock lookup - was Catalog::ajaxGetInventoryDisplay(),
            // now the shared derivation against whs/get_inventory_and_pricing. #301
            import('./partials/superseded-inventory.js').then(function (m) {
                m.initSupersededInventory();
            });
        } else if (s(1) === 'history' || s(1) === 'for_print' || s(1) === 'submit') {
            import('./partials/orders.js');
        } else if (s(1) === 'view') {
            import('./partials/checkout-inventory.js').then(function (m) {
                m.initCheckoutInventory();
            });
        }
    }

    if (isCP) {
        // Admin shell (off-canvas sidebar, tooltips) — loads on every CP page
        import('./partials/control_panel/admin-shell.js').then(function (m) {
            m.initAdminShell();
        });

        if (s(1) === 'reports') {
            import('./partials/control_panel/reports.js');
            var reportLoaders = {
                accounts:   function () { return import('./partials/control_panel/reports-accounts.js'); },
                brands:     function () { return import('./partials/control_panel/reports-brands.js'); },
                categories: function () { return import('./partials/control_panel/reports-categories.js'); },
                items:      function () { return import('./partials/control_panel/reports-items.js'); },
                pages:      function () { return import('./partials/control_panel/reports-pages.js'); },
            };
            var loader = reportLoaders[s(2)];
            if (loader) loader();
        }

        if (s(1) === 'order_settings') {
            import('./partials/control_panel/order-settings.js');
        }

        if (s(1) === 'ymm') {
            import('./partials/control_panel/ymm.js');
        }

        if (s(1) === 'brands') {
            import('./partials/control_panel/brands.js');
        }

        if (s(1) === 'categories') {
            import('./partials/control_panel/categories.js');
        }

        // The Ranking page's only-dirty submission (spec #1032). NOT optional polish: without it
        // the page posts one <select> per catalog row, php's max_input_vars (default 1000) drops
        // everything past the first 1,000, and the save writes the surviving prefix. It also
        // initialises the two list filters, which had no caller before this branch existed.
        if (s(1) === 'ranking') {
            import('./partials/control_panel/ranking.js').then(function (m) {
                m.initRanking();
            });
        }

        if (s(1) === 'users') {
            import('./partials/control_panel/users.js');
        }

        if (s(1) === 'design') {
            import('./partials/control_panel/design.js');
        }

        if (s(1) === 'pages') {
            import('./partials/control_panel/custom-page.js');
        }

        //  'file_manager', not 'file-manager': $_uri_segs maps '-' to '_' before json_encode,
        //  same as 'order_settings' and 'lost_sales' above.
        if (s(1) === 'file_manager') {
            import('./partials/control_panel/file-manager.js');
        }

        if (s(1) === 'lost_sales') {
            import('./partials/control_panel/lost-sales.js');
        }
    }

    // The storefront Locations page (#883). Branched on a DOM MARKER rather than on a segment,
    // and it is the only branch in this router that has to be: the page's URL is a per-site
    // setting (locations_page_slug), so there is no fixed s(0) to match. The marker is rendered
    // by the page body itself, so the test is "is this that page" rather than "is this that
    // URL", which is the same question one layer closer to the truth.
    if (document.querySelector('[data-locations-search]')) {
        import('./partials/locations-search.js').then(function (m) {
            m.initLocationsSearch();
        });
    }
})();
